import { type FC } from 'react';
import DeviceConfigurationModal from './DeviceConfigurationModal';
import DeviceAliasModal from './aliasModal/DeviceAliasModal';
import CloneDeviceModal from './cloneDeviceModal/CloneDeviceModal';

const DeviceConfigurationGlobalModals: FC = () => {
  return (
    <>
      <DeviceConfigurationModal />
      <DeviceAliasModal />
      <CloneDeviceModal />
    </>
  );
};

export default DeviceConfigurationGlobalModals;
